<template>
  <div class="Monitoring">
    <div id="container">
      <app-header :now=2 :showSingle="showSingle"></app-header>
      <div class="left_menu">
        <div class="logo">
          <img src="/static/img/logo.png"/>
          <span>智达云服务平台</span>
        </div>
        <ul>
          <router-link  v-for="(item,index) in user_left" :to="item.route!=null?{name:item.route}:''" :key="index"
                @click.native="addClassFun(index)" :class='[{active:index==Level_1_menu},"aa"]' tag="li" event="click">
            <span :class=[item.icon]></span>
            <span>{{item.name}}</span>
            <div v-if="item.children != null"><img src="/static/img/menu_maker.png" alt=""></div>
            <ul v-if="item.children != null">
              <router-link v-for="(item2,index) in item.children" :to="{name:item2.route}" :class="['bb']" tag="li" :key="index" event="click">{{item2.name}}
              </router-link>
            </ul>
          </router-link>
        </ul>
      </div>
      <div class="container_box">
        <router-view  @getMessage="showMsg"></router-view>
        <!--<div style="font-family: '微软雅黑';font-size: 90px;color: #ffffff;padding-top: 15%;padding-left: 10%">欢迎光临远程监控模块</div>-->
      </div>
    </div>
  </div>
</template>

<script>
  // import HelloWorld from './components/HelloWorld'
  import Header from "./Header";

  export default {
    name: 'monitoring',
    components: {
      "app-header": Header,
    },
    data() {
      return {
        showSingle:true,
        Level_1_menu:0,
        Level_2_menu:0,
        left: [
          {
            icon: 'icon-1',
            name: '智慧照明',
            show: false,
            children: [
              {name: '统计概览', route: 'LampStatistics'},
              {name: '设备详情', route: 'LampManagement'},
              {name: '历史记录', route: 'LampHistory'},
            ]
          }, {
            icon: 'icon-2',
            name: '环境监测',
            show: false,
            children: [
              {name: '统计概览', route: 'EnvironmentStatistics'},
              {name: '历史记录', route: 'EnvironmentHistory'},
              //{name: '设备管理', route: 'EnvironmentManagement'},
            ]
          },
          {
            icon: 'icon-3',
            name: '智慧安防',
            show: false,
            children: [
              {name: '安防监控', route: 'ProtectionMonitoring'},
               {name: '视频管理', route: 'ProtectionVideo'},
            ]
          },
          {
            icon: 'icon-4',
            name: '无线WiFi',
            show: false,
            children: [
              {name: '统计概览', route: 'WifiStatistics'},
              {name: '收益分析', route: 'WifiEarnings'},
              {name: '广告主管理', route: 'WifiAdManagement'}
            ]
          }, {
            icon: 'icon-5',
            name: '信息发布',
            show: false,
            children: [
              {name: '统计概览', route: 'MsgStatistics'},
              {name: '媒体资源', route: 'MsgLED_resource'},
              {name: '节目管理', route: 'MsgEvent_managing'},
              {name: '设备管理', route: 'MsgLED_management'},
              {name: '广告主管理', route: 'MsgLED_main_ad'}
            ]
          },
          {
            icon: 'icon-6',
            name: '智能音箱',
            show: false,
            children: [
              {name: '统计概览', route: 'LoudspeakerStatistics'},
              {name: '媒体资源', route: 'LoudspeakerEvent_managing'},
              {name: '计划任务', route: 'LoudspeakerManagement'},
              {name: '实时任务', route: 'LoudspeakerTemporary_duty'},
              // {name: '广告主管理', route: 'LoudspeakerAdvertising'},
            ]
          },
          {
            icon: 'icon-7',
            name: '一键报警',
            show: false,
            children: [
              {name: '设备管理', route: 'AlarmManagement'},
            ]
          },

          /*{
            icon: 'icon-8',
            name: '充电桩',
            show: true,
            children: [
              {name: '今日统计', route: 'Charging_pileTodayStatistics'},
              // {name: '数据统计', route: 'Charging_pileStatistics'},
            ]
          },*/
          // {
          //   icon: 'icon-9',
          //   name: 'RFID监测',
          //   show: false,
          //   children: [
          //     {name: 'RFID', route: 'RFID'},
          //   ]
          // }
        ],
        userx: [
          {
            icon: 'icon-3',
            name: '智慧安防',
            show: false,
            children: [
              {name: '安防监控', route: 'ProtectionMonitoring'},
              {name: '视频管理', route: 'ProtectionVideo'},
            ]
          },
        ],
        user_left:[],
      }

    },
    created() {
      this.changeUser();
    },
    mounted(){

    },
    methods: {
      addClassFun: function (index) {
        this.qwerqwre = index;
      },
      showMsg (lv1,lv2) {   // methods方法  val即为子组件传过来的值
        this.Level_1_menu=lv1;
        this.Level_2_menu=lv2;
      },
      //权限判断
      changeUser:function () {
        var  user = localStorage.getItem('user')
        if (user == "aplhjk"){
         this.user_left = this.userx
        }else {
          this.user_left = this.left
          this.showSingle = false;
        }
      },
    },






    updated() {
      let cc = this.Level_2_menu;
      $(function () {
        let aa = $(".aa"),
          bb = $(".bb");
        aa.css('display', 'block');
        aa.find('ul').hide();
        $(".active").find('ul').show();
        $(".active").find('ul').show().children('li').eq(cc).addClass('now');
        aa.click(function () {
          $(this).find('ul').slideDown(500);
          $(this).siblings().children("ul").slideUp(500);
        });
        bb.click(function () {
          bb.removeClass('now');
          $(this).addClass('now');
        })
      })
    }
  }
</script>

<style>
  .left_menu {
    width: 270px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: -webkit-linear-gradient(left, #1f55a9, #006d9f); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #1f55a9, #006d9f); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #1f55a9, #006d9f); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #1f55a9, #006d9f); /* 标准的语法 */
  }

  .left_menu .logo {
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left_menu .logo img {
    margin-right: 10px;
  }

  .left_menu .logo span {
    font-size: 22px;
    color: #ffffff;
    font-weight: bold;
  }

  .left_menu ul {
    width: 100%;
    height: calc(100% - 78px);
    overflow-y: auto;
  }

  .left_menu > ul > li {
    line-height: 55px !important;
    min-height: 55px;
    position: relative;
    cursor: pointer;
  }

  .left_menu > ul > li span:nth-child(1) {
    margin-left: 37px;
    margin-right: 25px;
    font-size: 20px;
    color: #ffffff;
    display: inline-block;
  }

  .left_menu > ul > li span:nth-child(2) {
    color: #ffffff;
  }

  .left_menu > ul > li div {
    position: absolute;
    right: 37px;
    top: 0;
  }

  .left_menu > ul > li > ul {
    width: 100%;
  }

  .left_menu > ul > li > ul > li {
    height: 50px;
    margin-left: 85px;
    color: #ffffff;
    cursor: pointer;
  }

  .left_menu > ul > .active {
    height: auto;
    background: rgba(15, 49, 79, 0.5);
    position: relative;
  }

  .left_menu > ul > .active:before {
    width: 3px;
    height: 55px;
    left: 0;
    top: 0;
    content: '';
    z-index: 10;
    background: #4a62be;
    display: block;
    position: absolute;
  }

  .left_menu > ul > .active ul {
    background: -webkit-linear-gradient(left, #1f55a9, #006d9f); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #1f55a9, #006d9f); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #1f55a9, #006d9f); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #1f55a9, #006d9f); /* 标准的语法 */
  }

  .left_menu > ul > .active ul .now {
    color: #00f0ff;
  }

  .container_nav {
    padding-left: 270px;
    width: 100%;
    height: 30px;
    background: #1a5c9c;
    box-sizing: border-box;
  }

  .container_nav > span {
    width: 80px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #FFFFFF;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    cursor: pointer;
  }

  .container_nav > span > a {
    width: 8px;
    height: 8px;
    background: url("/static/img/nav_close.png") no-repeat center center;
    margin-left: 4px;
  }

  .container_nav > .container_nav_now {
    background: #2677c6;
  }

  .container_box {
    padding-left: 270px;
    background: url("/static/img/bg.jpg") no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
    height: calc(100% - 78px);
    overflow-y: auto;
    box-sizing: border-box;
  }

  .information_box {
    position: relative;
    margin-top: 20px;
    float: left;
    background: #0b2f54;
  }

  .gridding {
    background: url("/static/img/gridding.png") #0b2f54 repeat;
  }

  .light_border {
    box-shadow: 0 0 10px #3494f6 inset;
    border: 1px solid #4b9ffc;
  }

  .border_top_left, .border_top_right, .border_bottom_left, .border_bottom_right {
    width: 26px;
    height: 26px;
    position: absolute;
    background: url("/static/img/border.png") no-repeat center center;
  }

  .border_top_left {
    left: -2px;
    top: -2px;
  }

  .border_top_right {
    right: -2px;
    top: -2px;
    transform: rotate(90deg);
  }

  .border_bottom_left {
    left: -2px;
    bottom: -2px;
    transform: rotate(-90deg);
  }

  .border_bottom_right {
    right: -2px;
    bottom: -2px;
    transform: rotate(180deg);
  }

  .h_light_right {
    width: 4px;
    height: 180px;
    background: url("/static/img/H_light-right.png") no-repeat center center;
    position: absolute;
    right: -2px;
  }

  .information_title {
    position: absolute;
    z-index: 2;
    width: 236px;
    height: 35px;
    background: url("/static/img/i_title.png") no-repeat center center;
    top: -18px;
    left: 50%;
    margin-left: -118px;
  }

  .information_title_sm {
    position: absolute;
    z-index: 2;
    width: 142px;
    height: 35px;
    background: url("/static/img/l_title.png") no-repeat center center;
    top: -18px;
    left: 50%;
    margin-left: -71px;
  }

  .information_title > p, .information_title_sm > p {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    font-size: 20px;
    color: #fbff67;
  }

  .information_title > div, .information_title_sm > div {
    width: 180px;
    height: 6px;
    position: absolute;
    left: 57px;
    bottom: -3px;
    background: url("/static/img/H_light.png") no-repeat center center;
  }

  .information_title_sm > div {
    left: -10px !important;
  }

  .information_content {
    width: 100%;
    height: 100%;
  }

  .table_warning {
    background: #ec354f;
  }

  .table_normal {
    background: #00fafe;
  }

  .anchorBL {
    display: none;
  }
  input[type='checkbox'] {
    width: 20px;
    height: 20px;
    -webkit-appearance: none;
    border-radius: 2px;
    background: url(/static/img/nocheckbox.png) no-repeat center;
    background-size: 100% 100%;
    outline: none;
  }

  input[type=checkbox]:checked {
    background: url(/static/img/checkbox.png) no-repeat center center;
    background-size: 100% 100%;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: transparent; /*滚动条的背景颜色*/
    -webkit-border-radius: 0; /*滚动条的圆角宽度*/
  }

  ::-webkit-scrollbar {
    width: 8px; /*滚动条的宽度*/
    height: 8px; /*滚动条的高度*/
  }

  ::-webkit-scrollbar-thumb { /*垂直滚动条的样式*/
    height: 50px;
    background-color: #95bee5;
    -webkit-border-radius: 4px;
    outline-offset: -2px;
  }

  ::-webkit-scrollbar-thumb:hover { /*滚动条的hover样式*/
    height: 50px;
    background-color: #00f0ff;
    -webkit-border-radius: 4px;
  }

  input::-webkit-input-placeholder{
    color:#a2b9d1;
  }
  input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#a2b9d1;
  }
  input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#a2b9d1;
  }
  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #a2b9d1;
  }


  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0 0;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span{
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }
  .search_options_box > select,.search_options_box > input {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    appearance: none;
    padding-left: 10px;
    background: transparent !important;
    border: 1px solid #a2b9d1 !important;
    color: #a2b9d1;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }
  .search_options_box  input{
    border-radius: 6px !important;
    background: transparent !important;
    border: 1px solid #a2b9d1 !important;
    color: #a2b9d1 !important;
  }
  .search_options_box >  input{
    width: calc(50% - 36px);
  }
  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    min-width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }
  .publish {
    background: #21b868;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #188d4f;
  }

  .publish:active {
    background: #188d4f;
  }
  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }
  .warning {
    background: #f24d4d;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #bb2323;
  }

  .warning:active {
    background: #bb2323;
  }

  .publish:active {
    background: #188d4f;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
  .mark {
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    z-index: 999;
    left: 0;
    top: 0;
  }

  .mark_close {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    left: 0;
    top: 0;
  }
  #msg {
    height: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #00f0ff;
    font-weight: bold;
  }
.tip{
  color: #FFFFFF;
  text-align:center;
  font-size: 20px !important;
}

  .model {
    padding: 20px;
    box-sizing: border-box;
  }

  .model > h1 {
    font-size: 20px;
    color: #00f0ff;
    height: 40px;
    line-height: 40px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #264a7c;
    margin-bottom: 10px;
  }

  .model > h1 > div {
    float: right;
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .model > h1 > div > label {
    font-size: 16px;
    line-height: 40px;
    color: #FFFFFF;
    margin-bottom: 0;
  }

  .model > h1 > div > label > select, .model > h1 > div > label > input {
    border: 1px solid #FFFFFF;
    border-radius: 4px;
    background: transparent;
    height: 32px;
    line-height: 32px;
    margin: 0 5px;
    width: 120px;
    color: #FFFFFF;
    outline: none;
  }

  .model > h1 > div > label > select > option {
    color: #000000;
  }

  .model > div {
    width: 100%;
    height: auto;
    border-radius: 8px;
    overflow: hidden;
  }
  .model > div>h1{
    font-size: 24px;
    color: #FFFFFF;
    margin: 20px 0;
    text-align: center;
  }
  .model_input_box {
    width: 100%;
    height: 32px;
    margin: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .model_input_box > div:nth-child(1) {
    width: 25%;
    padding-right: 20px;
    box-sizing: border-box;
  }

  .model_input_box > div:nth-child(1) > span {
    width: 100%;
    display: inline-block;
    height: 32px;
    font-size: 16px;
    line-height: 32px;
    text-align: right;
    color: #FFFFFF;
  }

  .model_input_box > div:nth-child(2) {
    width: 75%;
    padding-right: 20px;
    box-sizing: border-box;
  }

  .model_input_box > div:nth-child(2) > input {
    width: 100%;
    display: inline-block;
    height: 32px;
    font-size: 16px;
    line-height: 32px;
    padding: 0 20px;
    color: #FFFFFF;
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #FFFFFF;
    background: transparent;
    outline: none;
  }

  .sbt_box {
    width: 100%;
    height: 80px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Monitoring.vue